import React, { Fragment } from "react";
import alphabet from "../../helpers/alphabet";

import { groupMedicationsByLetter } from "../../helpers/groupByLetter";

const MedicationFilters = ({ letter, setLetter, results }) => {
  let filters = alphabet;

  if (results) {
    const groupedMeds = groupMedicationsByLetter(results);

    filters = groupedMeds.map(result => {
      return result.letter;
    });
  }

  return (
    <form className="ListingFilters u-form">
      <div className="l-padding">
        <div className="ListingFilters-wrap l-wrap">
          <fieldset className="AlphabetFilter ListingFilters-group">
            <input
              id="letter-all"
              type="radio"
              name="letter"
              value=""
              onChange={event => setLetter(event.target.value)}
              checked={letter === ""}
            />
            <label className="AlphabetFilter-all" htmlFor="letter-all">
              All
            </label>

            {filters.map((letter, i) => (
              <Fragment key={i}>
                <input
                  id={`letter-${letter}`}
                  type="radio"
                  name="letter"
                  value={letter}
                  onChange={event => setLetter(event.target.value)}
                />
                <label
                  className="AlphabetFilter-letter"
                  htmlFor={`letter-${letter}`}
                >
                  {letter}
                </label>
              </Fragment>
            ))}
          </fieldset>
        </div>
      </div>
    </form>
  );
};

export default MedicationFilters;
